import type { CustomerInfoDto } from "../../services/CustomerService";
import CustomerId from "../../state/CustomerId";
import type { CustomerInfo } from "../../types";

export const toCustomerInfo = (dto: CustomerInfoDto): CustomerInfo => ({
  customerId: CustomerId.from(dto.customerId.toString()),
  name: dto.name,
});
